// src/utils/stickerApi.ts
// QRシール生成API（rl-api-17-stickers, api.readlinker.com/stickers）
//
// 実際の画像/PDF生成はKANRI_ID時代に作られた旧Lambda（Pillow・qrcode・reportlab・PyPDF2）
// にそのまま委譲している。このAPIは受付・所有権チェック・タイトル解決・生成依頼・
// 履歴管理のみを担う。生成は非同期処理で、完了するとメールでPDFのダウンロードリンクが届く。
// モバイル版 lib/services/sticker_api.dart と同じ契約。

import axios from 'axios';
import { NEW_API } from '../config/api';

function authHeaders(idToken: string) {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
  };
}

export interface GenerateStickersResult {
  status: string;
  book_count: number;
  email: string;
}

/** POST /stickers operation_type=generate_stickers */
export async function generateStickers(
  globalBookIds: string[],
  libraryName: string,
  note: string,
  idToken: string,
  includeClassification: boolean = false,
  libraryNameBgColor: string | null = null,
): Promise<GenerateStickersResult> {
  const res = await axios.post(
    NEW_API.STICKERS,
    {
      operation_type: 'generate_stickers',
      global_book_ids: globalBookIds,
      library_name: libraryName,
      library_name_bg_color: libraryNameBgColor,
      note,
      include_classification: includeClassification,
    },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data as GenerateStickersResult;
}

export interface GeneratedStickerHistoryItem {
  generated_id: number;
  note: string | null;
  generated_at: string | null;
  expiration_at: string | null;
}

/** GET /stickers — 過去に生成したシールPDFの一覧（新しい順） */
export async function listGeneratedStickers(idToken: string): Promise<GeneratedStickerHistoryItem[]> {
  const res = await axios.get(NEW_API.STICKERS, { headers: authHeaders(idToken) });
  return res.data?.data?.items ?? [];
}

/** POST /stickers operation_type=regenerate_download_url（保存済みURLは24時間で失効するため都度再発行） */
export async function regenerateDownloadUrl(generatedId: number, idToken: string): Promise<string> {
  const res = await axios.post(
    NEW_API.STICKERS,
    { operation_type: 'regenerate_download_url', generated_id: generatedId },
    { headers: authHeaders(idToken) },
  );
  return res.data?.data?.url as string;
}
